/** `/room/<token>?product=<id>`: a saved room opened with a catalogue
 *  product's card up in the parts picker — a gear list's "Use in my room",
 *  for someone signed in. The visitor says where it goes, so nothing in a
 *  saved room changes without them. The room page resolves the id against
 *  the catalogue (an unknown one opens the room as it is), and the editor
 *  drops the parameter once it has shown it. */
export const PRODUCT_PARAM = 'product';

export function roomWithProductHref(token: string, productId: string): string {
  return `/room/${encodeURIComponent(token)}?${PRODUCT_PARAM}=${encodeURIComponent(productId)}`;
}
